import { motion } from "framer-motion";
import {
  ShieldCheck,
  GlobeHemisphereEast,
  CrownSimple,
  HandHeart,
  TrendUp,
  Sparkle,
  Compass,
} from "@phosphor-icons/react";

const ITEMS = [
  {
    icon: GlobeHemisphereEast,
    title: "Global exposure for Goa-based businesses",
    span: "lg:col-span-7 lg:row-span-2",
    accent: true,
    body: "Project your venture to a curated network of international enterprises, family offices, hospitality groups, and strategic capital — without leaving Goa.",
  },
  {
    icon: ShieldCheck,
    title: "Curated & verified opportunities",
    span: "lg:col-span-5",
    body: "Every listing passes structured onboarding standards.",
  },
  {
    icon: CrownSimple,
    title: "Premium network access",
    span: "lg:col-span-5",
    body: "High-trust ecosystem of decision-makers only.",
  },
  {
    icon: HandHeart,
    title: "Strategic matchmaking",
    span: "lg:col-span-4",
    body: "Right introductions, every time.",
  },
  {
    icon: TrendUp,
    title: "Tourism & hospitality growth",
    span: "lg:col-span-4",
    body: "From resorts to retreats — accelerate scale.",
  },
  {
    icon: Sparkle,
    title: "Free onboarding for Goa businesses",
    span: "lg:col-span-4",
    body: "Zero entry barriers. Period.",
  },
];

export const WhyGoaSetu = () => {
  return (
    <section
      id="why"
      data-testid="why-section"
      className="relative bg-[#02060D] py-24 md:py-32"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        {/* Section heading */}
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-8 mb-16">
          <div className="max-w-2xl">
            <div className="flex items-center gap-3 mb-6">
              <span className="text-xs tracking-[0.3em] uppercase text-[#D1B677] font-medium">
                Why CountGoa
              </span>
            </div>
            <h2 className="font-serif text-white text-3xl sm:text-4xl lg:text-5xl tracking-tight leading-tight">
              Powering Goa. <span className="italic text-[#D1B677]">Connecting the World.</span>
            </h2>
          </div>
          <p className="text-[#A1AEBF] max-w-md text-base leading-relaxed">
            A trust-first ecosystem engineered for serious capital, sophisticated
            partners, and ambitious Goa-based founders.
          </p>
        </div>

        {/* Bento grid */}
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-6 auto-rows-[200px]">
          {ITEMS.map((it, i) => {
            const Icon = it.icon;
            return (
              <motion.div
                key={i}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-50px" }}
                transition={{ duration: 0.6, delay: i * 0.06 }}
                data-testid={`why-card-${i}`}
                className={`${it.span} group relative p-8 border ${
                  it.accent
                    ? "bg-gradient-to-br from-[#0C5A48]/30 to-[#02060D] border-[#D1B677]/20"
                    : "bg-white/[0.02] border-white/8"
                } hover:border-[#D1B677]/40 transition-all duration-500 backdrop-blur-sm flex flex-col justify-between overflow-hidden`}
              >
                {it.accent && (
                  <div className="absolute -right-20 -top-20 w-72 h-72 rounded-full bg-[#D1B677]/5 blur-3xl pointer-events-none" />
                )}
                <div className="flex items-start justify-between relative z-10">
                  <Icon
                    size={it.accent ? 42 : 32}
                    weight="light"
                    className="text-[#D1B677] group-hover:scale-110 transition-transform duration-500"
                  />
                  <span className="font-serif italic text-[#A1AEBF]/40 text-sm">
                    /{String(i + 1).padStart(2, "0")}
                  </span>
                </div>
                <div className="relative z-10">
                  <h3
                    className={`font-serif text-white ${
                      it.accent ? "text-2xl lg:text-3xl" : "text-lg lg:text-xl"
                    } leading-snug mb-3`}
                  >
                    {it.title}
                  </h3>
                  <p
                    className={`text-[#A1AEBF] ${
                      it.accent ? "text-base" : "text-sm"
                    } leading-relaxed`}
                  >
                    {it.body}
                  </p>
                </div>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default WhyGoaSetu;
